import React from 'react'
import {  GridItem } from "@chakra-ui/react"

export const GridCol = (props) => {
    const { base= 12, sm= 6, md= 4, lg= 4 } = props
  return (
    <GridItem colSpan={{ base: base, sm: sm, md: md, lg: lg }}>{props.children}</GridItem>
  )
}

export const GridFullCol = (props) => {
  const { base= 12, sm= 12, md= 12, lg= 12 } = props
  return (
    <GridItem colSpan={{ base: base, sm: sm, md: md, lg: lg }}>{props.children}</GridItem>
  )
}